// Configuration file that contains all global variables that defines important Data

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '182c8c83-d49c-44f9-8038-d3f16ed5aee8';
// Time to Automatically-close the form window
export const MODAL_CLOSE_SEC = 2;
